import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Validacion {
  descripcion: string;
  fechaAlta: string; // ISO string (puedes convertirla a Date si prefieres)
  idCotizacion: number;
  idTipoValidacion: number;
  status: string;
}
@Injectable({
  providedIn: 'root',
})
export class MigrationUtilityService {
  public URL_API = environment.apiURLNew;
  constructor(private http: HttpClient) {}

  public getQuotationValidations(quotationId: number): Observable<any[] | null> {
    const userId = localStorage.getItem('userId');
    return this.http
      .get<any[] | null>(this.URL_API + `/getQuotationValidations/${quotationId}/${userId}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public changeQuotationStatus(body: {
    quotationId: number;
    userId: number;
    newStatus: string | number;
    comment: string;
  }): Observable<any[] | null> {
    return this.http.post<any[] | null>(this.URL_API + `/changeQuotationStatus`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public deleteGuarantor(quotationId: number, repeatIndex: number): Observable<any | null> {
    return this.http
      .delete<any>(this.URL_API + `/quotations/${quotationId}/guarantors/${repeatIndex}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public deleteAttorney(quotationId: number, repeatIndex: number): Observable<any | null> {
    return this.http
      .delete<any>(this.URL_API + `/quotations/${quotationId}/attorneys/${repeatIndex}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getValidations(
    quotationId: number,
  ): Observable<Validacion[] | null | { message: string; hasValidations: number }> {
    return this.http
      .get<Validacion[] | null>(this.URL_API + `/getValidations/${quotationId}/1`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
